import React, { useState, useEffect, useRef } from 'react';
import { Modal, Table, Button, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './RelationshipModel.module.scss';
import http from '@/assets/api/http';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import { XPagination } from '@/components/xqxc_ui';
import * as api from '@/apis/user/crowdsourcingRider'
import { autoPageNum, autopageSize } from '@/assets/config';

function RelationshipModel(props) {
    const page = useRef({ pageSize: autopageSize, pageNum: autoPageNum });

    const [confirmLoading, setConfirmLoading] = useState(false)
    const [cardNum, setCardNum] = useState('')
    const [tableIndex, setTableIndex] = useState('-1')
    const [dataList, setDataList] = useState([])
    const [logsDataList, setLogsDataList] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const title = props.valueType === 'change' ? '修改关系链' : '骑士关系变更日志'


    const _handleOk = () => {
        if(selectedRowKeys.length == 0){
            message.error('请选择运力公司')
            return
        }
        let query = {
            riderId:props.data.id,
            smallTransportId:selectedRowKeys[0]
        }
        api.riderChangeSmallTransport(query).then(res => {
            message.success('修改成功')
            props.closeModal('update')
        })
    }

    const _searchCompanyHandle = () => {

    }

    useEffect(() => {
        if (props.valueType == 'change') {
            searchHandle()
        }
        else {
            api.riderChangeLogs({ id: props.data.id }).then(res => {
                setLogsDataList(res.result.logs)
            })
        }

    }, [])

    const searchHandle = (usecache) => {
        if (usecache !== 'usecache') {
            page.current = { pageNum: autoPageNum, pageSize: autopageSize };
        }
        let params = {
            transportNameOrId: cardNum,
            pageNum: usecache == 'usecache' ? page.current.pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: usecache == 'usecache' ? page.current.pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        }
        api.smallTransportList(params).then(res => {
            setDataList(res.result.dataList)
        })
    }

    const onSelectChange = (record) => {
        setSelectedRowKeys(record)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        type: 'radio'
    }

    const changeList = () => {
        // return (
        //     <>
        //         <div className={styles.tableItem}>
        //             <div className={styles.tableTitle}>
        //                 <p className={styles.changeId}>小运力公司ID</p>
        //                 <p className={styles.changeName}>小运力公司名称</p>
        //             </div>
        //             <div className={styles.tableContent}>
        //                 {
        //                     dataList.map((item, index) => {
        //                         return (
        //                             <div className={`${styles.conItem} ${index == tableIndex ? styles.conActive : ''}`} onClick={() => { setTableIndex(index) }} key={item.id}>
        //                                 <p className={styles.changeId}>{item.id}</p>
        //                                 <p className={styles.changeName}>{item.transportName}</p>
        //                             </div>
        //                         )
        //                     })
        //                 }
        //             </div>
        //         </div>
        //         <XPagination
        //             // resultTotal={resultTotal}
        //             pageSize={page.current.pageSize}
        //             pageNum={page.current.pageNum}
        //             onChange={paginationChange}
        //         />
        //     </>
        // )
        const columns = [
            {
                title: '小运力公司ID',
                dataIndex: 'id',
                key: 'id',
                width: cellWidth.small,
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
            {
                title: '小运力公司名称',
                dataIndex: 'transportName',
                key: 'transportName',
                width: cellWidth.normal,
                align: 'center',
                onCell: tooltipStyle,
                render: tooltip
            },
        ]
        return (
            <>
                <Table
                    rowKey={(r) => r.id}
                    columns={columns}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: '300px' }}
                    rowSelection={rowSelection}
                />
                <XPagination
                    // resultTotal={resultTotal}
                    pageSize={page.current.pageSize}
                    pageNum={page.current.pageNum}
                    onChange={paginationChange}
                />
            </>
        )
    }

    const logsList = () => {
        // const columns = [
        //     {
        //         title: '操作时间',
        //         dataIndex: 'time',
        //         key: 'time',
        //         width: cellWidth.normal,
        //         align: 'center',
        //         onCell: tooltipStyle,
        //         render: tooltip
        //     },
        //     {
        //         title: '操作人',
        //         dataIndex: 'name',
        //         key: 'name',
        //         width: cellWidth.normal,
        //         align: 'center',
        //         onCell: tooltipStyle,
        //         render: tooltip
        //     },
        //     {
        //         title: '操作内容',
        //         dataIndex: 'content',
        //         key: 'content',
        //         width: cellWidth.big,
        //         align: 'center',
        //         onCell: tooltipStyle,
        //         render: tooltip
        //     },
        // ]
        // return (
        //     <Table
        //         rowKey={(r) => r.time}
        //         columns={columns}
        //         dataSource={logsDataList}
        //         pagination={false}
        //         scroll={{ y: '300px' }}
        //     />
        // )
        return (
            <div className={styles.tableItem}>
                <div className={styles.tableTitle}>
                    <p className={styles.logsTime}>操作时间</p>
                    <p className={styles.logsName}>操作人</p>
                    <p className={styles.logsContent}>操作内容</p>
                </div>
                <div className={styles.tableContent}>
                    {
                        logsDataList.length > 0 ? logsDataList.map((item, index) => {
                            return (
                                <div key={index}>
                                    <p className={styles.logsTime}>{item.gmtCreate}</p>
                                    <p className={styles.logsName}>{item.opName}</p>
                                    <p className={styles.logsContent}>{item.content}</p>
                                </div>
                            )
                        }) : <div className={styles.noData}>暂无相关日志</div>
                    }
                </div>
            </div>
        )
    }

    // 表格分页
    const paginationChange = (pageSize, pageNum) => {
        page.current = { pageSize, pageNum }
        searchHandle('usecache')
    }

    const onFooter = () => {
        return (
            <>
                {
                    props.valueType == 'change' ? <div>
                        <Button onClick={props.closeModal}>取消</Button>
                        <Button type="primary" onClick={_handleOk}>确定</Button>
                    </div> : null
                }
                {
                    props.valueType == 'journal' ? <div>
                        <Button onClick={props.closeModal}>关闭</Button>
                    </div> : null
                }
            </>
        )
    }

    return (
        <Modal
            width={props.valueType === 'change' ? 890 : 700}
            centered
            title={title}
            visible={true}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={props.closeModal}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
            footer={onFooter()}
        >
            <div>
                <div className={styles.modalTitle}>
                    <span>当前骑士信息</span>
                    <div className={styles.name}>姓名：{props.data.realName || '-'} ({props.data.mobilePhone})</div>
                    <div>所属小运力公司：{props.data.smallTransportName || '-'}</div>
                </div>
                {
                    props.valueType === 'change' ? <div className={styles.search}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='小运力公司名称:'
                                    placeholder='请输入小运力公司名称'
                                    value={cardNum}
                                    bindThis={setCardNum}
                                    bindName='cardNum'
                                    inputStyle={{ width: '240px' }}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={searchHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div> : null
                }
                <div className={props.valueType === 'change' ? styles.ChangeTableCon : styles.tableCon}>
                    {
                        props.valueType === 'change' ? changeList() : logsList()
                    }
                </div>
            </div>
        </Modal>
    );
}

RelationshipModel.propTypes = {
    data: PropTypes.object, // 弹窗传递参数
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};


export default RelationshipModel;

